var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoverTableTabsNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H6C2.68629 0 0 2.68629 0 6V26C0 29.3137 2.68629 32 6 32H26C29.3137 32 32 29.3137 32 26V6C32 2.68629 29.3137 0 26 0Z",
    fill: "#F0F5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1721_3161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.615 9.231H22.153C22.3161 9.231 22.4725 9.29579 22.5879 9.41113C22.7032 9.52646 22.768 9.68289 22.768 9.846V12.923H16.615V9.231ZM15.385 12.923V9.231H9.846C9.68289 9.231 9.52646 9.29579 9.41113 9.41113C9.29579 9.52646 9.231 9.68289 9.231 9.846V12.923H15.385ZM9.231 14.154V17.846H15.385V14.154H9.231ZM16.616 14.154H22.77V17.846H16.615L16.616 14.154ZM16.616 19.077H22.77V22.154C22.77 22.3171 22.7052 22.4735 22.5899 22.5889C22.4745 22.7042 22.3181 22.769 22.155 22.769H16.615L16.616 19.077ZM9.231 22.154V19.077H15.385V22.769H9.846C9.68289 22.769 9.52646 22.7042 9.41113 22.5889C9.29579 22.4735 9.231 22.3171 9.231 22.154ZM8 9.846C8 9.35641 8.19449 8.88687 8.54068 8.54068C8.88687 8.19449 9.35641 8 9.846 8H22.154C22.6436 8 23.1131 8.19449 23.4593 8.54068C23.8055 8.88687 24 9.35641 24 9.846V22.154C24 22.6436 23.8055 23.1131 23.4593 23.4593C23.1131 23.8055 22.6436 24 22.154 24H9.846C9.35641 24 8.88687 23.8055 8.54068 23.4593C8.19449 23.1131 8 22.6436 8 22.154V9.846Z",
    fill: "#203662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1721_3161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverTableTabsNewIcon);
export default __webpack_public_path__ + "static/media/hover_table_tabs_new_icon.929df3c60f97907ce555f8be171e215a.svg";
export { ForwardRef as ReactComponent };